import {
	Timeline
} from 'antd';
import {
	WeaNewScroll
} from 'ecCom';
import Detail from './Detail';

export default class Line extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			details,
			scrollY
		} = this.props;

		return (
			<div className='chart'>
				<WeaNewScroll ecId={`${this && this.props && this.props.ecId || ''}_WeaNewScroll@j8v64v`} height={scrollY - 110}>
					<div className='timeline'>
							<Timeline ecId={`${this && this.props && this.props.ecId || ''}_Timeline@ul3x3n`}>
								{
									details.map((detail, index) => {
										return (
											<Timeline.Item ecId={`${this && this.props && this.props.ecId || ''}_undefined@qlfway@${index}`}>
												<Detail ecId={`${this && this.props && this.props.ecId || ''}_Detail@a5pot4@${index}`} detail={detail}/>
											</Timeline.Item>
										)
									})
								}
							</Timeline>
					</div>
				</WeaNewScroll>
			</div>
		);
	}

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrmAttendance/components/absenceDetail/Timeline.js